import { render, staticRenderFns } from "./MileagePoint.vue?vue&type=template&id=618b40f9&scoped=true"
import script from "./MileagePoint.vue?vue&type=script&lang=js"
export * from "./MileagePoint.vue?vue&type=script&lang=js"
import style0 from "./MileagePoint.vue?vue&type=style&index=0&id=618b40f9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618b40f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618b40f9')) {
      api.createRecord('618b40f9', component.options)
    } else {
      api.reload('618b40f9', component.options)
    }
    module.hot.accept("./MileagePoint.vue?vue&type=template&id=618b40f9&scoped=true", function () {
      api.rerender('618b40f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/MileagePoint.vue"
export default component.exports